import m from "mithril";
/** @typedef {import('mithril').Vnode} Vnode */

const DarkMode = {
  oninit: (/** @type {Vnode} */ vnode) => {
    const saved = localStorage.getItem("theme");
    const dark =
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches;
    const theme = saved || (dark ? "dark" : "light");
    document.documentElement.setAttribute("data-theme", theme);
    vnode.state.is_dark = theme === "dark";
  },
  view: (/** @type {Vnode} */ vnode) => {
    return m(
      "button.mode-toggle",
      {
        onclick: () => {
          vnode.state.is_dark = !vnode.state.is_dark;
          const theme = vnode.state.is_dark ? "dark" : "light";
          document.documentElement.setAttribute("data-theme", theme);
          localStorage.setItem("theme", theme);
        },
      },
      vnode.state.is_dark ? "⚪ Light Mode" : "⚫ Dark Mode",
    );
  },
};

export default DarkMode;
